const DatetimeFormattingEnum = Object.freeze({
  TIME_ONLY: 'HH:mm:ssZ',
  DATE_ONLY: 'YYYY-MM-DD',
  DATETIME: 'YYYY-MM-DD HH:mm:ssZ',
  DATETIME_ROUNDED_HOUR: 'YYYY-MM-DD h A',
  ROUNDED_HOUR: 'h A'
})

export default DatetimeFormattingEnum
